import {CLASS_ITEM, CLASS_ITEM_LAST} from '../constants';

class Multiselect {
  constructor(element$) {
    this._selects$ = element$;

    this._selectRound$ = this._selects$.find('[data-voc-sportsdata-multiselect-round]');
    this._selectGroup$ = this._selects$.find('[data-voc-sportsdata-multiselect-group]');
    this._results$     = $('[data-voc-sportsdata-multiselect-results]');

    this._selectRound$.on('change', this.onChange.bind(this));
    this._selectGroup$.on('change', this.onChange.bind(this));

    this._selectRound$.trigger('change');
  }

  onChange() {
    var round, group;
    round = this._selectRound$.val();
    group = this._selectGroup$.val();

    this._results$.find('[data-voc-sportsdata-multiselect-group]').hide();

    if (group !== '0') {
      this._results$.find(`[data-voc-sportsdata-multiselect-round="${round}"][data-voc-sportsdata-multiselect-group="${group}"]`).show();
      this._results$.find(`[data-voc-sportsdata-multiselect-round="${round}"][data-voc-sportsdata-multiselect-group="${group}"]:first`).prev().show();
    } else {
      this._results$.find(`[data-voc-sportsdata-multiselect-round="${round}"]`).show();
      this._results$.find(`[data-voc-sportsdata-multiselect-round="${round}"]${CLASS_ITEM}:not(${CLASS_ITEM_LAST})`).prev().show();
    }
  }
}

export default Multiselect;



// WEBPACK FOOTER //
// ./src/views/multiselect.js